import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AdminNav from "./adminnav";
import TrafficInsightsWidget from "./TrafficInsightsWidget";
import ContactSubmissionsWidget from "./ContactSubmissionsWidget";
import ScheduledSeoPagesWidget from "./ScheduledSeoPagesWidget";
import BulkSeoPageImportWidget from "./BulkSeoPageImportWidget";
import AiSeoEnhancerWidget from "./AiSeoEnhancerWidget";
import SeoAuditWidget from "./SeoAuditWidget";
import WebhookSettingsWidget from "./WebhookSettingsWidget";
import ChatSettingsWidget from "./ChatSettingsWidget";

function AdminLoading() {
  return (
    <div className="min-h-screen bg-slate-950 text-white flex items-center justify-center px-4">
      <div className="rounded-3xl border border-cyan-400/20 bg-white/10 p-8 shadow-2xl backdrop-blur max-w-md text-center">
        <div className="mx-auto mb-4 h-12 w-12 rounded-full border-4 border-cyan-300/30 border-t-cyan-300 animate-spin" />
        <h1 className="text-xl font-semibold">Checking admin session…</h1>
        <p className="mt-2 text-sm text-slate-300">You will be sent to login if your session expired.</p>
      </div>
    </div>
  );
}

export default function AdminDashboard() {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;

    const loginUrl = `/login?next=${encodeURIComponent(location.pathname + location.search)}`;

    const redirectToLogin = () => {
      navigate(loginUrl, { replace: true });
    };

    const checkSession = async () => {
      setLoading(true);
      try {
        const res = await fetch("/api/session.php", {
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        });
        const data = await res.json();
        if (cancelled) return;

        if (!res.ok || !data?.authenticated) {
          redirectToLogin();
          return;
        }

        setAuthenticated(true);
      } catch (_) {
        if (!cancelled) redirectToLogin();
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    window.addEventListener("lpf-admin-auth-required", redirectToLogin);
    checkSession();

    return () => {
      cancelled = true;
      window.removeEventListener("lpf-admin-auth-required", redirectToLogin);
    };
  }, [location.pathname, location.search, navigate]);

  if (loading || !authenticated) {
    return <AdminLoading />;
  }

  return (
    <div className="min-h-screen bg-slate-100">
      <AdminNav />
      <main className="p-4 md:p-8 max-w-7xl mx-auto grid grid-cols-1 gap-8">
        <ChatSettingsWidget />
        <TrafficInsightsWidget />
        <ContactSubmissionsWidget />
        <ScheduledSeoPagesWidget />
        <BulkSeoPageImportWidget />
        <AiSeoEnhancerWidget />
        <SeoAuditWidget />
        <WebhookSettingsWidget />
      </main>
    </div>
  );
}
